import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { DropdownHeaderComponent } from '../../../common/dropdown/dropdown-header/dropdown-header.component';
import { DropdownComponent, DropdownWidth } from '../../../common/dropdown/dropdown.component';
import { TimeZonePickerDropdownListComponent } from '../time-zone-picker-dropdown-list/time-zone-picker-dropdown-list.component';

@Component({
  selector: 'rt-time-zone-picker-dropdown',
  templateUrl: 'time-zone-picker-dropdown.component.html',
  styleUrls: ['./time-zone-picker-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownComponent,
    DropdownHeaderComponent,
    TimeZonePickerDropdownListComponent,
    TranslatePipe,
  ],
})
export class TimeZonePickerDropdownComponent {
  @Output() public close: EventEmitter<void> = new EventEmitter();
  @Output() public zoneSelect: EventEmitter<string> = new EventEmitter();

  public DropdownWidth = DropdownWidth;
}
